<template>
  <div class="detail">
      <div class="detail-preview">
          <h1 class="detail-preview-title">
            <img class="detail-preview-title-icon"
                 src="../../assets/icon/detail/vip.png"
                 alt="">
            {{ matDetail.name }}
          </h1>
          <div class="detail-preview-container">
            <img style="width: 100%;"
                 draggable="false"
                 :src="`${matDetail.big_img}?x-oss-process=image/resize,w_1920,m_lfit/quality,q_80`" alt="">
          </div>
      </div>
      <div class="detail-info">
          <button class="detail-info-download" @click="handleDownload">
            <img class="detail-info-download-icon"
                 src="../../assets/icon/detail/download.png" alt="">
            立即下载
          </button>
          <!-- 次数统计       -->
          <ul class="detail-info-count">
            <li class="detail-info-count-item detail-info-count-browser">
              <img class="detail-info-count-icon"
                   src="../../assets/icon/detail/browser-count.png"
                   alt="">
              {{ browseCount }}
            </li>
            <li class="detail-info-count-item detail-info-count-download">
              <img class="detail-info-count-icon"
                   src="../../assets/icon/detail/download-count.png"
                   alt="">
              {{ downloadCount }}
            </li>
          </ul>
          <ul class="detail-info-copyright">
            <li class="detail-info-copyright-item">
              <div class="detail-info-copyright-title">版权所有: </div>
              <div class="detail-info-copyright-des">{{ matDetail.supplier }}</div>
            </li>
            <li class="detail-info-copyright-item">
              <div class="detail-info-copyright-title">版权说明： </div>
              <div class="detail-info-copyright-des">
                {{ matDetail.copyright_desc }}
              </div>
            </li>
            <li class="detail-info-copyright-item">
              <div class="detail-info-copyright-title">商用说明： </div>
              <div class="detail-info-copyright-des">
                {{ matDetail.commercial_desc }}
              </div>
            </li>
          </ul>
          <ul class="detail-info-copyright" style="border-top-width: 0;">
            <li class="detail-info-copyright-item">
              <div class="detail-info-copyright-title">使用格式: </div>
              <div class="detail-info-copyright-des">{{ matDetail.software }}</div>
            </li>
            <li class="detail-info-copyright-item">
              <div class="detail-info-copyright-title">资源格式： </div>
              <div class="detail-info-copyright-des">
                {{ matDetail.format }}
              </div>
            </li>
            <li class="detail-info-copyright-item">
              <div class="detail-info-copyright-title">资源大小： </div>
              <div class="detail-info-copyright-des">
                {{ matDetail.size }}
              </div>
            </li>
            <li class="detail-info-copyright-item">
              <div class="detail-info-copyright-title">资源作者： </div>
              <div class="detail-info-copyright-des">
                {{ matDetail.author }}
              </div>
            </li>
          </ul>
          <div class="detail-info-tag-title">相关标签：</div>
          <ul class="detail-info-tag">
            <li v-for="(item, index) in tags"
                :key="index"
                class="detail-info-tag-item">
              {{ item }}
            </li>
          </ul>
      </div>
  </div>
</template>

<script>
import { apiOfficeGetDetail, apiOfficeGetMatStatistics, apiOfficeDownload } from '@/api'
import { mapGetters } from 'vuex'
export default {
  name: 'Detail',
  data () {
    return {
      /** @description matDetail 素材结构
       id: 303
       class1_id: 31 // 一级分类id
       class2_id: 201 // 二级分类id
       class_id: 261 // 分类id(最末层级分类id)
       name: "财务收支表"
       detail: ""
       small_img: "https://img.6666ppt.com/test/mat_img/tit_27028594-62ae29c718d6851510ce6f8dfd1d7dd7.jpg"
       big_img: "https://img.6666ppt.com/test/mat_img/pic_27028594-62ae29c718d6851510ce6f8dfd1d7dd7.jpg"
       pay_type: 1, // 付费类型：0免费，1付费
       retail_price: 0, // 零售价格，精确到分
       author: "完美办公" // 作者
       tags: "财务,收支,预算,收入,支出" ， // 标签，逗号(,)分隔
       supplier: "" // 提供者
       copyright_desc: "" // 版权说明，默认为空
       commercial_desc: "" // 商用说明，默认为空
       software: "Microsoft Excel或WPS Office" , // 打开软件
       format: "XLSX"， // 格式
       size: "0.07 MB", // 大小
       */
      matDetail: {},
      // 浏览次数
      browseCount: 0,
      // 下载次数
      downloadCount: 0,
    }
  },
  created () {
    apiOfficeGetDetail({
      mat_id: this.matId
    }).then((response) => {
      const { info } = response
      this.matDetail = info
    })
    apiOfficeGetMatStatistics({
      mat_id: this.matId
    }).then((response) => {
      const { info } = response
      this.browseCount = info.browse_count
      this.downloadCount = info.download_count
    })
  },
  computed: {
    matId () {
      return Number.parseInt(this.$route.params.id)
    },
    tags () {
      if (!this.matDetail.tags) {
        return []
      }
      const tagSArray = this.matDetail.tags.split(',')
      if (tagSArray?.length) {
        return tagSArray
      }
      return []
    },
    ...mapGetters([
      'isVip',
      'avatar',
      'isLogin'
    ])
  },
  methods: {
    handleDownload () {
      if (!this.isLogin) {
        this.$store.commit('openLoginWindow')
        return
      }
      if (!this.isVip) {
        this.$store.commit('openVipDialog')
        return
      }
      apiOfficeDownload({
        mat_id: this.matId
      }).then((response) => {
        const { url } = response
        const aTag = document.createElement('a')
        aTag.download = 'true'
        aTag.href = url
        aTag.click()
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/style/styleVariable";
@import "../../assets/style/styleMixins";

  .border-mixins{
    background: #FFFFFF;
    border-radius: 8px;
  }

  .detail{
    width: @detail_page_width;
    margin: 50px auto;
    overflow: hidden;
    &-preview{
      width: 820px;
      box-sizing: border-box;
      .border-mixins;
      float: left;
      padding: 20px;
      &-title{
        font-size: 24px;
        color: #333333;
        .flex_align_center_mixins;
        padding: 18px 0 38px 0;
        font-weight: 500;
        &-icon{
          margin-right: 16px;
        }
      }
      &-container{
        height: 800px;
        overflow: auto;
        &::-webkit-scrollbar {
          /*滚动条整体样式*/
          width : 5px;  /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
          background   : #535353;
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          background   : #ededed;
        }
      }
    }
    &-info{
      float: right;
      width: 360px;
      box-sizing: border-box;
      .border-mixins;
      padding:  30px 40px;
      .flex_align_center_mixins;
      flex-direction: column;
      &-download{
        .clear_button_default_mixins;
        .flex_center_mixins;
        width: 100%;
        padding: 17px 0;
        font-size: 24px;
        color: #FFFFFF;
        border-width: 0;
        background: #3484FF;
        border-radius: 8px;
        &:hover{
          background-color: #257CEF;
        }
        &-icon{
          margin-right: 20px;
        }
      }
      &-count{
        width: 100%;
        .flex_align_center_mixins;
        padding: 35px 0;
        justify-content: space-around;
        &-item{
          .flex_align_center_mixins;
        }
        &-icon{
          margin-right: 14px;
        }
      }
      &-copyright{
        width: 100%;
        border-top: 1px solid #E7E7E7;
        border-bottom: 1px solid #E7E7E7;
        padding: 24px 0;
        &-item{
          margin-bottom: 20px;
          font-size: 14px;
          color: #666666;
          overflow: hidden;
          &:last-child{
            margin-bottom: 0;
          }
        }
        &-title{
          width: 72px;
          float: left;
        }
        &-des{
          overflow: hidden;
        }
      }
      &-tag{
        width: 100%;
        &-title{
          width: 100%;
          font-size: 14px;
          color: #666666;
          margin: 20px 0;
        }
        &-item{
          float: left;
          border: 1px solid #666666;
          border-radius: 10px;
          padding: 6px 11px;
          font-size: 12px;
          color: #666666;
          margin-right: 8px;
          margin-bottom: 12px;
        }
      }
    }
  }
</style>
